import { Tooltip } from '@mui/material'
import { isNil } from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'

const Round = ({
    color,
    text,
    textColor,
    size,
    tooltip,
}) => {
    const svg = (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={size}
            height={size}
            viewBox='0 0 62 62'
            version='1.1'
            id='svg4572'
            style={{ background: 'none', maxWidth: 'none' }}
        >
            <defs id='defs4566' />
            <g id='layer1' fill='none'>
                <circle
                    style={{
                        fill: color,
                        fillOpacity: 1,
                        stroke: '#000000',
                        strokeWidth: 0.5,
                        strokeMiterlimit: 4,
                        strokeDasharray: 'none',
                        strokeDashoffset: 0,
                        strokeOpacity: 1,
                    }}
                    id='path4564'
                    cx='31'
                    cy='31'
                    r='30'
                />
                <text
                    style={{
                        fontStyle: 'normal',
                        fontWeight: 'normal',
                        fontSize: 35,
                        lineHeight: 1.25,
                        fontFamily: 'sans-serif',
                        letterSpacing: 0,
                        wordSpacing: 0,
                        fill: textColor,
                        fillOpacity: 1,
                        stroke: 'none',
                        strokeWidth: 0.3,
                    }}
                    x='31'
                    y='31'
                    textAnchor='middle'
                    dominantBaseline='middle'
                    id='text818'
                >
                    {text}
                </text>
            </g>
        </svg>
    )
    if (isNil(tooltip)) return svg
    return (
        <Tooltip title={tooltip}>
            {svg}
        </Tooltip>
    )
}

Round.propTypes = {
    color: PropTypes.string,
    text: PropTypes.string,
    isCentered: PropTypes.bool,
    textColor: PropTypes.string,
    size: PropTypes.string,
    tooltip: PropTypes.string,
}

export default Round